import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

const CssTextField = styled(TextField)({

    '& label.Mui-focused': {
        color: "#14142B",
        margin: '0px',
        borderRadius: '24px'
    },
    '& .MuiInput-underline:after': {
        // borderBottomColor: 'white',
        borderRadius: '24px',
        color: "#14142B",

    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            // borderColor: 'white',
            borderRadius: '24px', color: "#14142B",
        },
        '&:hover fieldset': {
            // borderColor: 'white',
            borderRadius: '24px',
            color: "#14142B",
        },
        '&.Mui-focused fieldset': {
            // borderColor: 'white',
            borderRadius: '24px',
            color: "#14142B",
        },
        '&.Mui-disabled fieldset': {
            // borderColor: 'white',
            borderRadius: '24px',
            color: "#14142B",
        },
    },
});


export default function CustomizedInputs(props: any) {
    return (
        <Box

            sx={{
                display: 'grid',
                width:"100%"
            }}
        >
            <CssTextField
                label={props.label}
                style={props.style}
                placeholder={props.placeholder}
                id="custom-css-outlined-input"
                value={props.value}
                onChange={props.onChange}
                onCut={props.onChange}
                onCopy={props.onChange}
                onPaste={props.onChange}
                onBlur={props.onError}
                disabled={props.disabled}
                InputProps={{
                    style: {
                        color: "#14142B",
                        height: '36px',
                        width:"100%"

                    }
                }}
                InputLabelProps={{
                    style: {
                        color: props?.error?.length ? 'red' : "#14142B",
                        marginLeft: '15px',
                        width:"100%"

                    },
                }} />

        </Box>
    );
}